import React from 'react';
import PropTypes from 'prop-types';
import TextField from '../../../TextField';

const NumberBetweenFilter = ({
  onChange,
  operator,
  settings,
  suggestions,
  value: values,
  ...props
}) => {
  const handleChange = isStart => number => {
    const value = isStart ? [number, values[1]] : [values[0], number];

    if (onChange && typeof onChange === 'function') {
      onChange({}, value);
    }
  };

  return (
    <>
      <TextField
        {...props}
        name="startNumber"
        label="Start"
        type="number"
        value={values[0] ?? ''}
        onChange={handleChange(true)}
      />
      <TextField
        {...props}
        name="endNumber"
        label="End"
        type="number"
        value={values[1] ?? ''}
        onChange={handleChange(false)}
      />
    </>
  );
};

NumberBetweenFilter.propTypes = {
  onChange: PropTypes.func,
  operator: PropTypes.string,
  settings: PropTypes.object,
  suggestions: PropTypes.array,
  value: PropTypes.array,
};

NumberBetweenFilter.defaultProps = {
  onChange: undefined,
  operator: undefined,
  settings: {},
  suggestions: [],
  value: [],
};

export default NumberBetweenFilter;
